module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Android-e39fb45379d48931fa28094d359a20b4.svg";